import { useCallback, useEffect, useState } from "react";

const ACCESS_WAIT_MS = 10_000;

/** Keep a pending access check recoverable, and discard timeouts from an old org. */
export function useBoundedWait(key: string, ready: boolean) {
  const [state, setState] = useState({ key, attempt: 0, expired: false });
  const attempt = state.key === key ? state.attempt : 0;

  if (state.key !== key) {
    setState({ key, attempt: 0, expired: false });
  } else if (ready && state.expired) {
    setState({ key, attempt, expired: false });
  }

  useEffect(() => {
    if (ready) return;
    const timer = window.setTimeout(() => {
      setState((current) =>
        current.key === key && current.attempt !== attempt
          ? current
          : { key, attempt, expired: true }
      );
    }, ACCESS_WAIT_MS);
    return () => window.clearTimeout(timer);
  }, [key, ready, attempt]);

  const retry = useCallback(() => {
    setState((current) => ({
      key,
      attempt: current.key === key ? current.attempt + 1 : 1,
      expired: false,
    }));
  }, [key]);

  return { failed: !ready && state.key === key && state.expired, retry };
}
